import React from "react";
import { AiOutlineExclamation } from "react-icons/ai";

function SyncModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      
      {/* Modal Box */}
      <div className="bg-white rounded-2xl p-6 w-[400px] text-center shadow-lg">
        
        {/* Warning Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-yellow-100 flex items-center justify-center">
            <AiOutlineExclamation className="text-yellow-600 text-3xl" />
          </div>
        </div>

        {/* Message */}
        <h2 className="text-lg font-semibold">
          Are you sure?
        </h2>

        <p className="text-sm text-gray-600 mt-2 mb-6">
          Do you want to Sync this template?
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4">
          
          {/* Confirm Button */}
          <button
            onClick={onConfirm}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Yes, Sync it
          </button>

          {/* Cancel Button */}
          <button
            onClick={onClose}
            className="px-5 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
          >
            Cancel
          </button>

        </div>
      </div>
    </div>
  );
}

export default SyncModal;